// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"54a5b638","988":"dfa9e59c"}[chunkId] + ".chunk.js";
};